var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row bg-white", attrs: { id: "panel-home" } },
    [
      _c("div", { staticClass: "col-6 pl-25 pr-25" }, [
        _c("img", {
          attrs: {
            id: "logo-noord-holland-noord",
            src: "/app/themes/mapping/dist/images/NHN_logo.svg",
            alt: "logo Noord-Holland Noord"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pages-container" },
          _vm._l(_vm.pages, function(page, index) {
            return _c("panel-home-group", {
              key: page.id,
              class: { isOpen: _vm.isOpen === index },
              attrs: { page: page },
              nativeOn: {
                click: function($event) {
                  _vm.toggleHeader(index)
                }
              }
            })
          })
        ),
        _vm._v(" "),
        _c("img", {
          attrs: {
            id: "logo-holland-boven-amsterdam",
            src: "/app/themes/mapping/dist/images/VHB_logo.svg",
            alt: "logo Holland Boven Amsterdam"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 pl-25 pr-25" }, [
        _c("h4", { attrs: { id: "kies-kaart" } }, [
          _vm._v("Kies een actuele kaart")
        ]),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.stories, function(story) {
            return _c("panel-story-group", {
              key: story.post_id,
              attrs: { story: story }
            })
          })
        ),
        _vm._v(" "),
        _c("h4", { attrs: { id: "kies-preset" } }, [
          _vm._v("Of kies een kaart met de volgende preset:")
        ]),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.presets, function(preset) {
            return _c("panel-preset-group", {
              key: preset.post_id,
              attrs: { preset: preset }
            })
          })
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/PanelHome.vue?vue&type=template&id=44d45f7f&
// module id = 60
// module chunks = 0